/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';
import { ConsoleStep } from '../../ConsoleStep/ConsoleStep.entity';
import { ConsoleBaseInstance } from '../Base/ConsoleBaseInstance.entity';

export type EntityConsoleDatastoreInstance = io.TypeOf<typeof ConsoleDatastoreInstance>;

export const ConsoleDatastoreInstance = io.intersection([
  ConsoleBaseInstance,
  io.type({
    blueprint: io.string,
    blueprintFile: io.string,
    deployedAt: io.number,
    deploymentUrl: io.string,
    provisioningSteps: ConsoleStep,
    secretKey: io.string,
  }),
]);
